'use client'
import { createBrowserPlatformService } from './createBrowserPlatformService/createBrowserPlatformService.js';

class PlatformService {
    static get implementation() {
        if (!PlatformService._implementation) {
            return createBrowserPlatformService(window);
        }
        return PlatformService._implementation;
    }
    static setImplementation(implementation) {
        PlatformService._implementation = implementation;
    }
    static get getOrigin() {
        return PlatformService.implementation.getOrigin;
    }
    static get getHost() {
        return PlatformService.implementation.getHost;
    }
    static get getHostname() {
        return PlatformService.implementation.getHostname;
    }
    static get getTLD() {
        return PlatformService.implementation.getTLD;
    }
    // Deeplink handling
    static get openURL() {
        return PlatformService.implementation.openURL;
    }
    static get openNewWindow() {
        return PlatformService.implementation.openNewWindow;
    }
}

export { PlatformService };
